export default "__VITE_ASSET__D5Nn0iXC__"